import axios from 'axios';
import { getToken } from './authService';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true' // For ngrok tunnels
  },
  timeout: 5000 // 5 second timeout
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
api.interceptors.response.use(
  response => response,
  error => {
    // For 401 responses, don't redirect - let the components handle it
    if (error.response && error.response.status === 401) {
      console.log('Authentication error:', error.response.data);
      // The component will handle the redirect if needed
    }
    return Promise.reject(error);
  }
);

export default api;